import { Controller } from "react-hook-form";

const CustomDate = ({
  type = "text",
  placeholder,
  onInputChange = undefined,
  name,
  rules,
  required = true,
  disabled = false,
  control,
  errors,
  suffix = null,
  prefix = null,
  className = "",
  label = "",
  defaultValue = "",
  min,
  max,
  onChange,
  ...props
}) => {
  const getFieldError = (errors, name) => {
    return name
      ?.split(".")
      .reduce((acc, part) => acc && acc[part], errors);
  };

  const fieldError = getFieldError(errors, name);

  // Helper to calculate age
  const calculateAge = (dateString) => {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const expandedRules = {
    ...rules,
    validate: {
      ...(rules?.validate || {}),
      ageValidation: (value) => {
        if (!value) return true;

        // Check if min/max are ages (numbers) or dates (strings with - or /)
        const isMinAge = min && !isNaN(min) && String(min).length < 4;
        const isMaxAge = max && !isNaN(max) && String(max).length < 4;

        if (isMinAge || isMaxAge) {
          const age = calculateAge(value);
          if (isMinAge && age < Number(min)) {
            return `Age must be minimum ${min} years.`;
          }
          if (isMaxAge && age > Number(max)) {
            return `Age must be maximum ${max} years.`;
          }
        }
        return true;
      },
    },
  };


  return (
    <div className={`input-group ${className}`}>
      {label && <label>{label}</label>}
      <div className="input-field">
        {prefix && (
          <div className="input--prefix">
            {typeof prefix === "function" ? prefix() : prefix}
          </div>
        )}
        <Controller
          name={name}
          control={control}
          rules={expandedRules}
          defaultValue={defaultValue}
          render={({ field }) => (
            <input
              {...field}
              type={type}
              required={required}
              disabled={disabled}
              placeholder={placeholder}
              // If min/max are ages, we don't pass them as date attributes directly unless converted
              // For simplicity, we rely on JS validation for age, and standard HTML min/max for dates
              min={min && isNaN(min) ? min : undefined} 
              max={max && isNaN(max) ? max : undefined}
              className={`form-control ${fieldError ? "input__invalid" : ""}`}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
                if (onInputChange) {
                  onInputChange(e);
                }
              }}
              {...props}
            />
          )}
        />
        {suffix && (
          <div className="input--suffix">
            {typeof suffix === "function" ? suffix() : suffix}
          </div>
        )}
      </div>
      {fieldError && (
        <div className="input--helper__invalid">{fieldError?.message}</div>
      )}
    </div>
  );
};

export default CustomDate;
